import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';

import systemStatuses from 'data/system_statuses';
import billingStatuses from 'data/billing_statuses';

export default function Filters({
  keyword,
  setKeyword,
  setSystemStatus,
  setBillingStatus,
  setPaymentVerification,
}) {
  return (
    <div className="invite_search">
      <Form className="" horizontal>
        <Row>
          <Col md={6}>
            <FormGroup controlId="company_name">
              <Col componentClass={ControlLabel} sm={4}>
                Name or Email
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup controlId="status">
              <Col componentClass={ControlLabel} sm={4}>
                System Status
              </Col>
              <Col sm={8}>
                <Select
                  isClearable
                  onChange={(option) => {
                    setSystemStatus(option == null ? '' : option.value);
                  }}
                  options={systemStatuses}
                />
              </Col>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup controlId="status">
              <Col componentClass={ControlLabel} sm={4}>
                Billing Status
              </Col>
              <Col sm={8}>
                <Select
                  isClearable
                  onChange={(option) => {
                    setBillingStatus(option == null ? '' : option.value);
                  }}
                  options={billingStatuses}
                />
              </Col>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup controlId="status">
              <Col componentClass={ControlLabel} sm={4}>
                ID Verification
              </Col>
              <Col sm={8}>
                <Select
                  isClearable
                  onChange={(option) => {
                    setPaymentVerification(option == null ? '' : option.value);
                  }}
                  options={[
                    { label: 'Unverified', value: 'Unverified' },
                    { label: 'Verified', value: 'Verified' },
                  ]}
                />
              </Col>
            </FormGroup>
          </Col>

        </Row>
      </Form>
    </div>
  );
}

Filters.propTypes = {
  keyword: PropTypes.string.isRequired,
  setKeyword: PropTypes.func.isRequired,
  setSystemStatus: PropTypes.func.isRequired,
  setBillingStatus: PropTypes.func.isRequired,
  setPaymentVerification: PropTypes.func.isRequired,
};
